export default {
  name: "poststation",
  webTitle: "POSTSTATION",
  primaryColor: "#e60000",
  secondaryColor: "#e60000",
  contactURL: "",
  hideHelpButton: true,
  bannerPrefix: "POSTSTATION",
  shopCodePrefix: "PT",
  wallet: true,
  forceUseWallet: true,
  useDefaultAPIKey: true,
  serviceName: {
    inter: false,
    lazada: false,
    dhl: false,
    shippop: false,
    shopee: false,
    doubleA: false,
    kerry: true,
    kerry_quick: false,
    kerry_orange: false,
    line: false
  },
  manageVision: {
    brancePackage: false,
    menuTopUpCreditSA: true,
  },
  unitKG: false,
  manageDisable: {
    weightSuperAdmin: false,
    dimensionSuperAdmin: false,
    costSuperAdmin: false,
  },
  btnCancelBill: false,
  bannerCampaignPosition: "DF_POSPOSTSTATION",
  dropoffEasyShip: false,
  dropoffKerry: false,
  failReport: true,
  menuLayout: {
    reportInvoice: true,
  },
  LineConfig: {
    shopBank: false,
  }
};
